import { render, staticRenderFns } from "./Deepsearch.vue?vue&type=template&id=17c9432b&scoped=true"
import script from "./Deepsearch.vue?vue&type=script&lang=js"
export * from "./Deepsearch.vue?vue&type=script&lang=js"
import style0 from "./Deepsearch.vue?vue&type=style&index=0&id=17c9432b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c9432b",
  null
  
)

export default component.exports